var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editable-value',{attrs:{"type":"number","value":_vm.displayValue,"validate":_vm.validateHours,"disabled":_vm.disabled},on:{"input":_vm.hoursChanged},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Timer")]},proxy:true},{key:"text",fn:function(){return [_vm._v("Skriv inn antall estimerte timer:")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }